import {Slider} from './Slider.js';

export class SocialFeedSlider {
    constructor(socialFeed) {
        this.feed = socialFeed;
        this.slider = socialFeed.querySelector('[data-social-feed-slider]');
        if (!this.slider) {
            return;
        }

        this.activeFilterIds = [];
        this.allFeedsLoaded = false;
        this.defaultLimit = this.slider.dataset.socialFeedLimit ?? 10;
        this.wrapper = this.slider.querySelector('.swiper-wrapper');

        // Reuse the shared slider engine as the source of truth for all defaults
        // (modules, speed, reduced-motion, direction, a11y, navigation wiring).
        // Only the feed-specific view configuration is passed in.
        this.swiper = new Slider(this.slider, JSON.stringify({
            slidesPerView: {xs: 1, sm: 2, md: 2, lg: 3, xl: 4},
            spaceBetween: 16,
            rewind: false,
            arrows: 'overlay',
        }));

        this.initEvents();
        this.initFilter();
    }

    initEvents() {
        // Lazily load the remaining feeds the first time the user moves forward.
        this.swiper.on('slideNextTransitionStart', () => {
            if (this.allFeedsLoaded) {
                return;
            }
            this.allFeedsLoaded = true;
            this.loadFeeds(this.defaultLimit, 200);
        });
    }

    initFilter() {
        this.feed.querySelectorAll('.tx-bd-filter').forEach((item) => {
            item.addEventListener('click', () => {
                let filterIsActive = item.classList.contains('tx-bd-filter-active');
                let filterType = item.dataset.bdFilter;

                if (filterType === 'all') {
                    if (!filterIsActive) {
                        item.classList.add('tx-bd-filter-active');
                        this.feed.querySelectorAll('.tx-bd-filter:not(.tx-bd-filter-all)').forEach((filterItem) => {
                            filterItem.classList.remove('tx-bd-filter-active');
                        });
                    }
                } else {
                    item.classList.toggle('tx-bd-filter-active');
                    this.feed.querySelector('.tx-bd-filter.tx-bd-filter-all').classList.remove('tx-bd-filter-active');
                }

                if (this.feed.querySelectorAll('.tx-bd-filter.tx-bd-filter-active').length === 0) {
                    this.feed.querySelector('.tx-bd-filter.tx-bd-filter-all').classList.add('tx-bd-filter-active');
                    filterType = 'all';
                }

                // The reset control selects no type at all, so it is sent as an empty value rather
                // than as an id standing for "every type".
                this.activeFilterIds = [];
                if (filterType !== 'all') {
                    this.feed.querySelectorAll('.tx-bd-filter.tx-bd-filter-active').forEach(activeFilter => {
                        this.activeFilterIds.push(Number(activeFilter.dataset.bdFilter));
                    });
                }

                this.loadFeeds(0, this.defaultLimit);
            });
        });
    }

    loadFeeds(offset = 0, limit = 10) {
        let formData = new FormData();
        formData.append('tx_bdsocialfeed_showfeed[filter]', this.activeFilterIds.join(','));
        formData.append('tx_bdsocialfeed_showfeed[limit]', limit.toString());
        formData.append('tx_bdsocialfeed_showfeed[offset]', offset.toString());
        formData.append('tx_bdsocialfeed_showfeed[contentUid]', this.getContentUid());
        formData.append('tx_bdsocialfeed_showfeed[contentUidHmac]', this.getContentUidHmac());

        if (offset === 0) {
            this.feed.querySelector('.tx-bd-sliderDiv').classList.add('tx-bd-sliderDiv--loading');
        }

        let ajaxUrl = this.feed.querySelector('.tx-bd-source').dataset.bdSource;
        fetch(ajaxUrl, {
            method: 'POST',
            cache: 'no-cache',
            body: formData
        }).then(response => {
            if (response.status === 200) {
                return response.text();
            }
            return false;
        }).then(htmlResponse => {
            if (htmlResponse) {
                if (offset === 0) {
                    this.wrapper.innerHTML = htmlResponse;
                } else {
                    this.wrapper.innerHTML += htmlResponse;
                }
            }
        }).finally(() => {
            if (offset === 0) {
                this.allFeedsLoaded = false;
                this.feed.querySelector('.tx-bd-sliderDiv').classList.remove('tx-bd-sliderDiv--loading');
                this.swiper.slideTo(0, 0);
            }
            this.swiper.update();
        });
    }

    getContentUid() {
        return this.feed.querySelector('.tx-bd-sliderDiv').dataset.bdContentUid ?? '';
    }

    getContentUidHmac() {
        return this.feed.querySelector('.tx-bd-sliderDiv').dataset.bdContentUidHmac ?? '';
    }

}

document.querySelectorAll('.tx-bd-social-feed').forEach((item) => {
    new SocialFeedSlider(item);
});
